import { useState } from 'react'
import { checkEmail, requestOtp, verifyOtp, register } from '../utils/authApi'

export function useAuthFlow({ onSuccess }) {
  const [step, setStep] = useState('email')
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function submitEmail(emailValue) {
    setLoading(true)
    setError('')
    try {
      const { status } = await checkEmail(emailValue)
      setEmail(emailValue)

      if (status === 'known') {
        await requestOtp(emailValue)
        setStep('otp')
      } else if (status === 'unverified') {
        setStep('unverified')
      } else {
        setStep('register')
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Er is een fout opgetreden')
    } finally {
      setLoading(false)
    }
  }

  async function submitOtp(otp) {
    setLoading(true)
    setError('')
    try {
      const data = await verifyOtp(email, otp)
      localStorage.setItem('token', data.token)
      localStorage.setItem('user', JSON.stringify(data.user))
      onSuccess()
    } catch (err) {
      setError(err.response?.data?.error || 'Ongeldige inlogcode')
    } finally {
      setLoading(false)
    }
  }

  async function submitRegister(name) {
    setLoading(true)
    setError('')
    try {
      await register(email, name)
      setStep('registered')
    } catch (err) {
      setError(err.response?.data?.error || 'Er is een fout opgetreden bij het aanmelden')
    } finally {
      setLoading(false)
    }
  }

  function reset() {
    setStep('email')
    setEmail('')
    setError('')
  }

  return { step, email, loading, error, submitEmail, submitOtp, submitRegister, reset }
}
